/**
 * Nutrition consultation EMR sections — id, title, and the dot-path on TherapyReport
 * (rooted at nutritionSection.*) used to read/write narrative content.
 *
 * Mirrors src/mentor/components/AssessmentReport/assessmentReportSectionConfig.js. Source of truth
 * for the seeded EmrSection IDs is the backend migration
 * EmrNutritionConsultationSectionSupport.java; keep this list in sync if section ids/order change.
 */
export const NUTRITION_CONSULTATION_SECTIONS = [
  { id: 'nutrition_dietary_history', title: 'Dietary History', field: 'dietaryHistory' },
  { id: 'nutrition_anthropometry', title: 'Anthropometric Assessment', field: 'anthropometry' },
  { id: 'nutrition_biochemical_markers', title: 'Biochemical Markers', field: 'biochemicalMarkers' },
  { id: 'nutrition_dietary_recall', title: '24-hour Dietary Recall', field: 'dietaryRecall' },
  { id: 'nutrition_diet_plan', title: 'Diet Plan', field: 'dietPlanSummary' },
  { id: 'nutrition_physical_activity', title: 'Physical Activity Assessment', field: 'physicalActivityAssessment' },
  { id: 'nutrition_lifestyle_recommendations', title: 'Lifestyle Recommendations', field: 'lifestyleRecommendations' },
  { id: 'nutrition_goals', title: 'Goals', field: 'goals' },
  { id: 'nutrition_follow_up', title: 'Follow-up Plan', field: 'followUpPlan' },
]

export const NUTRITION_DIET_PLAN_SECTION_ID = 'nutrition_diet_plan'
